/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AssetProtocolDeleteAssetRequest {
  /** @format int32 */
  assetId: number;
}

export interface AssetProtocolGetAllAssetListResponse {
  assets: AssetProtocolGetAllAssetListResponseAsset[];
}

export interface AssetProtocolGetAllAssetListResponseAsset {
  /** @format int32 */
  id: number;
  name: string;
}

export interface AssetProtocolGetAssetRequest {
  /** @format int32 */
  id: number;
}

export interface AssetProtocolGetAssetResponse {
  /** @format int32 */
  id: number;
  images: string[];
  keywords: string[];
  name: string;
  officialUrl?: string | null;
  productType: PiracyCommonEnumsProductTypeEnum;
}

export interface AssetProtocolGetAssetImagesResponse {
  images: string[];
}

export interface AssetProtocolGetAssetListRequest {
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface AssetProtocolGetAssetListResponse {
  assets: AssetProtocolGetAssetListResponseAsset[];
}

export interface AssetProtocolGetAssetListResponseAsset {
  /** @format int32 */
  id: number;
  images: string[];
  name: string;
  officialUrl?: string | null;
  productType: PiracyCommonEnumsProductTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00"
   */
  updatedDate: string;
}

export interface AssetProtocolUpdateAssetRequest {
  /** @format int32 */
  id: number;
  keywords?: string | null;
  name?: string | null;
  officialUrl?: string | null;
  productType?: PiracyCommonEnumsProductTypeEnum;
}

export interface AuthProtocolGetInfoResponse {
  /** @format int32 */
  clientId: number;
  clientName: string;
  confirmNeeded: boolean;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  googleConfirmNeeded: boolean;
  userEmail: string;
  /** @format int32 */
  userId: number;
}

export interface AuthProtocolLoginRequest {
  email: string;
  password: string;
}

export interface AuthProtocolLoginResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthProtocolLogoutRequest {
  accessToken: string;
}

export interface AuthProtocolOktaLoginRequest {
  accessToken: string;
}

export interface AuthProtocolOktaLoginResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthProtocolRefreshTokenRequest {
  refreshToken: string;
}

export interface AuthProtocolRefreshTokenResponse {
  accessToken: string;
}

export interface ClientRequestProtocolAddNewRequestRequest {
  attachments: PiracyCommonModelAttachment[];
  crType: PiracyCommonEnumsCrCRTypeEnum;
  details: string;
}

export interface ClientRequestProtocolGetCrDetailsRequest {
  /** @format int32 */
  dbId: number;
}

export interface ClientRequestProtocolGetCrDetailsResponse {
  adminAttachments: PiracyCommonModelAttachment[];
  adminResponse?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  adminUpdatedDate?: string | null;
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  clientCrId: number;
  crStatus: PiracyCommonEnumsCrCRStatusEnum;
  crType: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  dbId: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requestedDate: string;
}

export interface ClientRequestProtocolGetCrHasNewBadgeResponse {
  crHasNew: boolean;
}

export interface ClientRequestProtocolGetCrListRequest {
  crStatus?: PiracyCommonEnumsCrCRStatusEnum;
  crType?: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
}

export interface ClientRequestProtocolGetCrListResponse {
  crList: ClientRequestProtocolGetCrListResponseCR[];
}

export interface ClientRequestProtocolGetCrListResponseCR {
  attachments: PiracyCommonModelAttachment[];
  /** @format int32 */
  clientCrId: number;
  crStatus: PiracyCommonEnumsCrCRStatusEnum;
  crType: PiracyCommonEnumsCrCRTypeEnum;
  /** @format int32 */
  dbId: number;
  details: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  requestedDate: string;
  showNewBadge: boolean;
}

export interface ClientRequestProtocolGetCrListCountRequest {
  crStatus?: PiracyCommonEnumsCrCRStatusEnum;
  crType?: PiracyCommonEnumsCrCRTypeEnum;
}

export interface ClientRequestProtocolGetCrListCountResponse {
  /** @format int32 */
  crCount: number;
}

export interface ClientRequestProtocolGetUploadUrlRequest {
  fileName: string;
}

export interface ClientRequestProtocolGetUploadUrlResponse {
  url: string;
}

export interface PerformanceProtocolAssetSection {
  data?: PerformanceProtocolAssetSectionAssetData[] | null;
  groupByFilter: PiracyCommonEnumsPerfPerfGroupByEnum;
  listingStatusFilter: PiracyCommonEnumsPerfPerfListingStatusEnum;
  type: PiracyCommonEnumsPerfPerfSectionTypeEnum;
}

export interface PerformanceProtocolAssetSectionAssetData {
  groupedData?: PerformanceProtocolAssetSectionAssetDataGroupedData[] | null;
  label: string;
  /** @format int32 */
  totalCount: number;
}

export interface PerformanceProtocolAssetSectionAssetDataGroupedData {
  /** @format int32 */
  count: number;
  groupLabel: string;
}

export interface PerformanceProtocolDomainSection {
  data?: PerformanceProtocolDomainSectionDomainData[] | null;
  groupByFilter: PiracyCommonEnumsPerfPerfGroupByEnum;
  listingStatusFilter: PiracyCommonEnumsPerfPerfListingStatusEnum;
  type: PiracyCommonEnumsPerfPerfSectionTypeEnum;
}

export interface PerformanceProtocolDomainSectionDomainData {
  groupedData?: PerformanceProtocolDomainSectionDomainDataGroupedData[] | null;
  label: string;
  /** @format int32 */
  totalCount: number;
}

export interface PerformanceProtocolDomainSectionDomainDataGroupedData {
  /** @format int32 */
  count: number;
  groupLabel: string;
}

export interface PerformanceProtocolGetAllSectionsRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetAllSectionsResponse {
  sectionList: PerformanceProtocolSection[];
}

export interface PerformanceProtocolGetAssetCsvRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolAssetSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetAssetDataRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolAssetSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetAssetDataResponse {
  data: PerformanceProtocolAssetSectionAssetData[];
}

export interface PerformanceProtocolGetDomainCsvRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolDomainSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetDomainDataRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolDomainSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetDomainDataResponse {
  data: PerformanceProtocolDomainSectionDomainData[];
}

export interface PerformanceProtocolGetOverviewCsvRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetOverviewDataRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetOverviewDataResponse {
  data: PerformanceProtocolOverviewSectionOverviewData;
}

export interface PerformanceProtocolGetStatusCsvRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolStatusSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetStatusDataRequest {
  assetIdList?: number[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  sectionInfo: PerformanceProtocolStatusSection;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface PerformanceProtocolGetStatusDataResponse {
  data: PerformanceProtocolStatusSectionStatusData[];
}

export interface PerformanceProtocolOverviewSection {
  data: PerformanceProtocolOverviewSectionOverviewData;
  type: PiracyCommonEnumsPerfPerfSectionTypeEnum;
}

export interface PerformanceProtocolOverviewSectionOverviewData {
  /** @format int32 */
  denied: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  enforced: number;
  /** @format int32 */
  reported: number;
}

export interface PerformanceProtocolReportGetListRequest {
  sortOrder: PiracyCommonEnumsSortOrderEnum;
}

export interface PerformanceProtocolReportGetListResponse {
  list: PerformanceProtocolReportGetListResponseReport[];
}

export interface PerformanceProtocolReportGetListResponseReport {
  filename: string;
  /** @format int32 */
  id: number;
  s3url: string;
  /**
   * @format date
   * @example "2023-03-01"
   */
  uploadedDate: string;
}

export type PerformanceProtocolSection =
  | PerformanceProtocolAssetSection
  | PerformanceProtocolDomainSection
  | PerformanceProtocolOverviewSection
  | PerformanceProtocolStatusSection;

export interface PerformanceProtocolStatusSection {
  cumulativeFilter: boolean;
  data?: PerformanceProtocolStatusSectionStatusData[] | null;
  frequencyFilter: PiracyCommonEnumsPerfPerfFrequencyEnum;
  groupByFilter: PiracyCommonEnumsPerfPerfGroupByEnum;
  listingStatusFilter: PiracyCommonEnumsPerfPerfListingStatusEnum;
  type: PiracyCommonEnumsPerfPerfSectionTypeEnum;
}

export interface PerformanceProtocolStatusSectionStatusData {
  groupedData?: PerformanceProtocolStatusSectionStatusDataGroupedData[] | null;
  label: string;
  /** @format int32 */
  totalCount: number;
}

export interface PerformanceProtocolStatusSectionStatusDataGroupedData {
  /** @format int32 */
  count: number;
  groupLabel: string;
}

export interface IoKtorHttpContentType {
  contentSubtype: string;
  contentType: string;
  parameters: IoKtorHttpHeaderValueParam[];
}

export interface IoKtorHttpHeaderValueParam {
  name: string;
  value: string;
}

export interface MonitoringGridViewProtocolCancelConfirmRequest {
  listingIdList: number[];
}

export interface MonitoringGridViewProtocolGetDetailRequest {
  /** @format int32 */
  id: number;
}

export interface MonitoringGridViewProtocolGetDetailResponse {
  assetName: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detectedDate: string;
  imageList: string[];
  /** @format int32 */
  listingId: number;
  listingUrl: string;
  profileName?: string | null;
  searchKeywordList: string[];
  searchMethod: PiracyCommonEnumsSearchMethodEnum;
  snapshotUrl?: string | null;
  /** @format int32 */
  subscription?: number | null;
  title: string;
  /** @format int32 */
  views?: number | null;
}

export interface MonitoringGridViewProtocolGetListResponse {
  list: MonitoringGridViewProtocolGetListResponseListing[];
}

export interface MonitoringGridViewProtocolGetListResponseListing {
  /** @format int32 */
  id: number;
  profileName: string;
  searchMethod: PiracyCommonEnumsSearchMethodEnum;
  thumbnailUrl: string;
  title: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updateDate: string;
  url: string;
}

export interface MonitoringGridViewProtocolGetPresignedUrlRequest {
  fileName: string;
}

export interface MonitoringGridViewProtocolGetPresignedUrlResponse {
  url: string;
}

export interface MonitoringGridViewProtocolPostConfirmRequest {
  docList?: MonitoringGridViewProtocolPostConfirmRequestFileRequest[] | null;
  listingIdList: number[];
  note?: string | null;
}

export interface MonitoringGridViewProtocolPostConfirmRequestFileRequest {
  fileName: string;
  url: string;
}

export interface MonitoringGridViewProtocolPostDismissRequest {
  listingIdList: number[];
}

export enum MonitoringMonitoringProtocolClientStatus {
  Detected = 'detected',
  Confirmed = 'confirmed',
  Reported = 'reported',
  Enforced = 'enforced',
  Denied = 'denied',
}

export interface MonitoringMonitoringProtocolExportCsvRequest {
  assetList?: number[] | null;
  channelGroup: PiracyClientModelChannelGroupEnum;
  clientStatus: MonitoringMonitoringProtocolClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  listingIdList?: number[] | null;
  search?: string | null;
  searchMethodList?: PiracyCommonEnumsSearchMethodEnum[] | null;
  sortColumn: PiracyCommonEnumsSortColumnEnum;
  sortOrder: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
  websiteIdList?: number[] | null;
}

export interface MonitoringMonitoringProtocolGetChannelGroupCountResponse {
  /** @format int32 */
  appStore: number;
  /** @format int32 */
  others: number;
  /** @format int32 */
  searchEngine: number;
  /** @format int32 */
  socialMedia: number;
}

export interface MonitoringMonitoringProtocolGetListingCountResponse {
  /** @format int32 */
  count: number;
}

export interface MonitoringMonitoringProtocolGetMonitoringCountRequest {
  assetList?: number[] | null;
  channelGroup: PiracyClientModelChannelGroupEnum;
  clientStatus: MonitoringMonitoringProtocolClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  search?: string | null;
  searchMethodList?: PiracyCommonEnumsSearchMethodEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
  websiteIdList?: number[] | null;
}

export interface MonitoringMonitoringProtocolGetMonitoringListRequest {
  assetList?: number[] | null;
  channelGroup: PiracyClientModelChannelGroupEnum;
  clientStatus: MonitoringMonitoringProtocolClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  searchMethodList?: PiracyCommonEnumsSearchMethodEnum[] | null;
  sortColumn: PiracyCommonEnumsSortColumnEnum;
  sortOrder: PiracyCommonEnumsSortOrderEnum;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
  websiteIdList?: number[] | null;
}

export interface MonitoringMonitoringProtocolGetStatusCountRequest {
  channelGroup: PiracyClientModelChannelGroupEnum;
}

export interface MonitoringMonitoringProtocolGetStatusCountResponse {
  /** @format int32 */
  confirmed: number;
  /** @format int32 */
  detected: number;
  /** @format int32 */
  reported: number;
}

export interface MonitoringMonitoringProtocolGetWebsiteFilterRequest {
  assetList?: number[] | null;
  channelGroup: PiracyClientModelChannelGroupEnum;
  clientStatus: MonitoringMonitoringProtocolClientStatus;
  /**
   * @format date
   * @example "2023-03-01"
   */
  endDate?: string | null;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  offset: number;
  search?: string | null;
  searchMethodList?: PiracyCommonEnumsSearchMethodEnum[] | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  startDate?: string | null;
}

export interface MonitoringMonitoringProtocolGetWebsiteFilterResponse {
  /** @format int32 */
  totalCount: number;
  websites: PiracyCoreModelIdNameCount[];
}

export interface MonitoringTableViewProtocolCancelConfirmRequest {
  listingIdList: number[];
}

export interface MonitoringTableViewProtocolGetListResponse {
  list: MonitoringTableViewProtocolGetListResponseListing[];
}

export interface MonitoringTableViewProtocolGetListResponseListing {
  assetName: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  detectedDate: string;
  domainName: string;
  /** @format int32 */
  id: number;
  searchKeywordList: string[];
  searchType: PiracyCommonEnumsSearchMethodEnum;
  url: string;
}

export interface MonitoringTableViewProtocolPostConfirmRequest {
  listingIdList: number[];
}

export interface MonitoringTableViewProtocolPostDismissRequest {
  listingIdList: number[];
}

export enum PiracyClientModelChannelGroupEnum {
  SearchEngine = 'searchEngine',
  SocialMedia = 'socialMedia',
  AppStore = 'appStore',
  Others = 'others',
}

export enum PiracyCommonEnumsProductTypeEnum {
  Webcomic = 'webcomic',
  Webnovel = 'webnovel',
  Game = 'game',
  Adult = 'adult',
  Sports = 'sports',
  Publishing = 'publishing',
  Music = 'music',
  Films = 'films',
  Animation = 'animation',
  ELearning = 'e-learning',
  Software = 'software',
}

export enum PiracyCommonEnumsSearchMethodEnum {
  Web = 'web',
  Image = 'image',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Tiktok = 'Tiktok',
  Twitter = 'Twitter',
  Douyin = 'Douyin',
  Youtube = 'Youtube',
  YoutubeShorts = 'Youtube Shorts',
  VK = 'VK',
  Dailymotion = 'Dailymotion',
  Vimeo = 'Vimeo',
  Twitch = 'Twitch',
  Bilibili = 'Bilibili',
  GooglePlay = 'Google Play',
  AppleAppstore = 'Apple Appstore',
  Telegram = 'Telegram',
  Discord = 'Discord',
}

export enum PiracyCommonEnumsSortColumnEnum {
  AssetName = 'asset_name',
  AssetType = 'asset_type',
  UpdatedDate = 'updated_date',
  SearchMethod = 'search_method',
  CreatedDate = 'created_date',
  DetectedDate = 'detected_date',
  Domain = 'domain',
  Views = 'views',
  Subscriptions = 'subscriptions',
  RelevancyScore = 'relevancy_score',
}

export enum PiracyCommonEnumsSortOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum PiracyCommonEnumsCrCRStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
  NotAvailable = 'not_available',
}

export enum PiracyCommonEnumsCrCRTypeEnum {
  Enforce = 'enforce',
  Retract = 'retract',
  AddWhitelist = 'add_whitelist',
  ChangeAsset = 'change_asset',
}

export enum PiracyCommonEnumsPerfPerfFrequencyEnum {
  Default = 'default',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export enum PiracyCommonEnumsPerfPerfGroupByEnum {
  None = 'none',
  Asset = 'asset',
  Domain = 'domain',
  SearchMethod = 'search_method',
}

export enum PiracyCommonEnumsPerfPerfListingStatusEnum {
  Detected = 'detected',
  Reported = 'reported',
  Removed = 'removed',
}

export enum PiracyCommonEnumsPerfPerfSectionTypeEnum {
  OverviewSection = 'overview_section',
  StatusSection = 'status_section',
  AssetSection = 'asset_section',
  DomainSection = 'domain_section',
}

export interface PiracyCommonModelAttachment {
  /** @format int32 */
  id?: number | null;
  name: string;
  s3Url: string;
}

export interface PiracyCommonProtocolFileResponse {
  /** @format byte */
  bytes: string;
  contentType: IoKtorHttpContentType;
  filename: string;
}

export interface PiracyCoreModelIdNameCount {
  /** @format int32 */
  count: number;
  /** @format int32 */
  id: number;
  name: string;
}
